import React from 'react';
import { sameDayRentals, multiDayRentals, additionalFees } from '@data/pricing';
import PricingCard from '@components/features/PricingCard';

const PricingSection: React.FC = () => {
  return (
    <section id="pricing" className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-8 text-center text-gray-900">
          Golf Cart Rental Pricing
        </h2>

        {/* Same-Day Rentals */}
        <div className="max-w-5xl mx-auto mb-8">
          <h3 className="text-xl font-semibold mb-4 text-gray-900">{sameDayRentals.title}</h3>
          <div className="grid md:grid-cols-3 gap-4">
            {sameDayRentals.tiers.map((tier) => (
              <PricingCard key={tier.id} tier={tier} />
            ))}
          </div>
        </div>

        {/* Multi-Day Rentals */}
        <div className="max-w-5xl mx-auto mb-8">
          <h3 className="text-xl font-semibold mb-4 text-gray-900">{multiDayRentals.title}</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {multiDayRentals.tiers.map((tier) => (
              <PricingCard key={tier.id} tier={tier} />
            ))}
          </div>
        </div>

        {/* Additional Info */}
        <div className="max-w-3xl mx-auto bg-gray-50 rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-4 text-gray-900">Additional Information</h3>
          <div className="space-y-3">
            {additionalFees.map((fee, index) => (
              <div key={index} className="flex justify-between items-center">
                <span className="text-gray-700">
                  {fee.label}
                  {fee.sublabel && (
                    <>
                      <br />
                      <span className="text-sm text-gray-500">{fee.sublabel}</span>
                    </>
                  )}
                </span>
                <span className="font-semibold text-gray-900">{fee.amount}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;